import { IDs } from '../../helpers/IDs';
import * as React from 'react';
import { WFormsTableWrapper } from '../../core/table/WFormsTableWrapper';
import { filterMethodFulltext } from '../../core/forms/helpers/filter_method_fulltext';
import parse from 'html-react-parser';

export interface AktuelleTermineTabelleProps {

}

export interface AktuelleTermineTabelleState {
    dataRows: Array<any>;
    refreshCnt: number;
}

export class AktuelleTermineTabelle extends React.Component<AktuelleTermineTabelleProps, AktuelleTermineTabelleState> {

    constructor(props: any) {
        super(props);
        this.state = {
            dataRows: null,
            refreshCnt: 0
        };
        this.onDataLoaded = this.onDataLoaded.bind(this);
    }

    render(): JSX.Element {
        const { dataRows, refreshCnt } = this.state;

        const customColumns: Array<any> = [
            {
                index: 3,
                accessor: 'inhalt_table',
                Header: 'Inhalt',
                id: 'inhalt_table',
                type: 'text',
                filterMethod: (filter: any, row: any) => filterMethodFulltext(filter, row._original, 'inhalt')
            }
        ];

        return (
            <div>
                <WFormsTableWrapper
                    key={IDs.ENT_AKTUELLE_TERMINE + refreshCnt}
                    entity={IDs.ENT_AKTUELLE_TERMINE}
                    module={IDs.MOD_ETOOL_ADMIN}
                    data={dataRows}
                    actions={['add', 'edit', 'delete']}
                    customCssStyle={{
                        formDialogWrapper: { width: 800 }
                    }}
                    customClass={'Custom-ETA'}
                    formLayout={'flowV2'}
                    showColumnsHelp={true}
                    hiddenColumns={['inhalt']}
                    customColumns={customColumns}
                    onDataLoaded={this.onDataLoaded}
                    columnWidths={[100, 200, 200, null, 100, 100]}
                    tablePageSize={5}
                />
            </div>
        );
    }

    onDataLoaded(dataRows: Array<any>) {
        const { refreshCnt } = this.state;
        if (Array.isArray(dataRows)) {
            this.processDataRows(dataRows);
            this.setState({ dataRows, refreshCnt: refreshCnt + 1 });
        }
    }

    processDataRows(rows: Array<any>) {
        rows.forEach((r: any) => {
            r.inhalt = typeof r.inhalt === 'string' ? r.inhalt : '';
            const p = parse(r.inhalt);
            r.inhalt_parse = p;
            r.inhalt_table = <div style={{ maxHeight: 100, overflow: 'auto', padding: '3px' }}>{p}</div>;
        });
    }
}
